function applyTheme(isDarkMode: boolean): void {
	document.body.setAttribute("data-theme", isDarkMode ? "dark" : "light");
}

export default applyTheme;
